import tailwindConfig from '@root/tailwind.config';
import {
  FillLayerSpecification,
  LayerSpecification,
  LineLayerSpecification,
  SymbolLayerSpecification,
} from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxSourceIds,
  AcresMapboxVectorSourceLayerIds,
  ZOOM_LEVELS,
} from '..';

const jade = tailwindConfig.theme.extend.colors.jade.DEFAULT;
const green40 = tailwindConfig.theme.extend.colors.green['40'];

const sharedSectionLayerConfig: Omit<LayerSpecification, 'type' | 'id'> = {
  layout: {
    visibility: 'visible',
  },
  maxzoom: ZOOM_LEVELS.SECTIONS.MAX,
  minzoom: ZOOM_LEVELS.SECTIONS.MIN,
  source: AcresMapboxSourceIds.SECTIONS,
  'source-layer': AcresMapboxVectorSourceLayerIds.SECTIONS,
} as Omit<LayerSpecification, 'type' | 'id'>;

export const sectionsFillLayer: FillLayerSpecification = {
  ...(sharedSectionLayerConfig as Omit<FillLayerSpecification, 'id' | 'type'>),
  id: AcresMapboxLayerIds.SECTION_FILL,
  paint: {
    'fill-color': 'transparent',
  },
  type: 'fill',
};

export const sectionLineLayer: LineLayerSpecification = {
  ...(sharedSectionLayerConfig as Omit<LineLayerSpecification, 'id' | 'type'>),
  id: AcresMapboxLayerIds.SECTION_LINE,
  paint: {
    'line-color': green40,
    'line-width': 1,
  },
  type: 'line',
};

export const sectionLabelLayer: SymbolLayerSpecification = {
  ...(sharedSectionLayerConfig as Omit<
    SymbolLayerSpecification,
    'id' | 'type'
  >),
  id: AcresMapboxLayerIds.SECTION_LABELS,
  layout: {
    'text-allow-overlap': true,
    'text-field': ['concat', ['get', 'FRSTDIVNO'], ' ', ['get', 'TWNSHPLAB']],
    'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
  },
  paint: {
    'text-color': 'white',
    'text-halo-color': 'black',
    'text-halo-width': 1.25,
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.SECTIONS_CENTROIDS,
  type: 'symbol',
};

export const sectionOutlineLayer: LineLayerSpecification = {
  ...(sharedSectionLayerConfig as Omit<LineLayerSpecification, 'id' | 'type'>),
  id: AcresMapboxLayerIds.SECTION_OUTLINE,
  maxzoom: 13.5,
  paint: {
    'line-color': jade,
    'line-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      1,
      0,
    ],
    'line-width': 5,
  },
  type: 'line',
};

export const sectionOutlinePermanentLayer: LineLayerSpecification = {
  ...sectionOutlineLayer,
  id: AcresMapboxLayerIds.SECTION_OUTLINE_PERMANENT,
};
